<template>
  <div>
    <div style="margin-top:10px;margin-bottom: 10px;text-align: right;">
      <span class="server">{{$t('lang.HangingDevice.successNumber')}}：{{printerList.printSuccessCount}}</span>
      <span class="server">{{$t('lang.HangingDevice.failNumber')}}：{{printerList.printFailCount}}</span>
      <span class="server">{{$t('lang.HangingDevice.totalNumber')}}：{{printerList.printFailCount + printerList.printSuccessCount}}</span>
       <span class="server">{{$t('lang.HangingDevice.finalTime')}}：{{printerList.lastPrintTs ? printerList.lastPrintTs : '-'}}</span>
    </div>
    <el-table 
      :data="printerList.printers" 
      border
      size="mini"
      :header-cell-style="{background:'#e4f1ff'}">
      <el-table-column :label="$t('lang.HangingDevice.alias')" prop="alias" align="center" min-width="150px">
        <template slot-scope="scope">
          <span class="fontStyle" v-if="scope.row.alias">{{scope.row.alias}}</span>
          <span class="fontStyle" v-else>{{scope.row.printer}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.vendor')" prop="vendor" align="center" width="150PX"> 
        <template slot-scope="scope">
          <span class="fontStyle">{{scope.row.vendor}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.type')" prop="type" align="center" min-width="250px">
         <template slot-scope="scope">
          <span class="fontStyle">{{scope.row.type}}</span>
        </template>
      </el-table-column>
      <el-table-column label="PID" align="center" prop="description">
        <template slot-scope="scope">
          <span class="fontStyle">{{scope.row.pid}}</span>
        </template>
      </el-table-column>
      <el-table-column label="VID" align="center" prop="description">
        <template slot-scope="scope">
          <span class="fontStyle">{{scope.row.vid}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.port')" align="center" prop="port">
        <template slot-scope="scope">
          <span class="fontStyle">{{scope.row.port}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.printeMethod')" align="center" prop="printType">
        <template slot-scope="scope">
          <span v-if="scope.row.printType == 0" class="fontStyle">socket</span>
          <span v-else class="fontStyle">http</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.status')" align="center" prop="status">
        <template slot-scope="scope">
          <div v-if="isConnected != 3">
            <el-tag type="danger">{{$t('lang.HangingDevice.offline')}}</el-tag>
          </div>
          <div v-else>
            <el-tag type="success" v-if="scope.row.status == 1">{{$t('lang.HangingDevice.online')}}</el-tag>
            <el-tag type="danger" v-else>{{$t('lang.HangingDevice.offline')}}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.Description')" align="center" prop="description" min-width="100px">
        <template slot-scope="scope">
          <span class="fontStyle">{{scope.row.description}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { hangingDevice } from '@/api/particulars'
export default {
  props: ['did', 'isConnected'],
  data() {
    return {
      printerList: {
        printSuccessCount: 0,
        printFailCount: 0,
        printers: []
      },
      timer: null
    }
  },
  mounted() {
    this.getPrinter()
    // 10s刷新一次下挂设备信息
    this.timer = setInterval(() => {
      this.getPrinter()
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getPrinter() {
      hangingDevice(this.did).then(res => {
        if(res.data.code === 0) {
          this.printerList = res.data.data || this.printerList          
          this.printerList.printSuccessCount = res.data.data.printSuccessCount ? res.data.data.printSuccessCount : 0
          this.printerList.printFailCount = res.data.data.printFailCount ? res.data.data.printFailCount : 0
        }
      }).catch(() => {})
    },
  }
}
</script>
<style scoped>
.fontStyle{
  padding-left: 10px;
  font-size: 0.25rem;
}
.server{
  color: #777777;
  font-size: 14px;
  margin-right: 20px;
}
</style>
<style scoped src='./particulars.css'></style>